import { FC } from "react";
import { Icon } from "../Icon/Icon";
import Paragraph from "../typography/Paragraph";
import Badge from "../Badge/Badge";
import { ISearchResultItem } from "../../hooks/useSearch";
import {
    StyledSearchResultList,
    StyledSearchResultItem,
    StyledLink,
    StyledImageWrapper,
    StyledSearchResultInfo,
    StyledBadges,
    StyledBadge,
} from "./searchSuggestList.style";
import { ReactComponent as FlagIcon } from "../../assets/icons/flag.svg";
import { ReactComponent as HammerIcon } from "../../assets/icons/hammer.svg";

interface ISearchResult {
    isMobile: boolean;
    pageUrl: string;
    pageName: string;
    searchResult: ISearchResultItem[] | undefined;
}

export const SearchSuggestList: FC<ISearchResult> = (props): JSX.Element => {
        const { isMobile, searchResult, pageUrl } = props;

    //TODO: find out for what is pageName here

    return (
        <StyledSearchResultList>
            {searchResult?.map(({ id, name, state_code, obligee_name }) => {
                const params = new URLSearchParams(window.location.search);
                // Remove search-form params so links don't include the current search filters
                params.delete("q");
                params.delete("state");
                params.delete("category");
                params.set("id", String(id));
                params.set("sc", String(state_code));
                const href = `${pageUrl}/application-form?${params.toString()}`;

                return (
                    <StyledSearchResultItem key={id}>
                        <StyledImageWrapper>
                            <StyledLink href={href}>
                                <Icon name="document" size={61} />
                            </StyledLink>
                        </StyledImageWrapper>
                        <StyledSearchResultInfo>
                            <StyledLink href={href}>
                                <Paragraph
                                    size={16}
                                    weight={500}
                                    lineHeight="1.5em"
                                    color="badge-link"
                                >
                                    {name}
                                </Paragraph>
                            </StyledLink>
                            <StyledBadges>
                                <StyledBadge>
                                    <Badge icon={<Icon name="flag" size={16} />}>
                                        {state_code}
                                    </Badge>
                                </StyledBadge>
                                {obligee_name && (
                                    <Badge icon={<HammerIcon />}>
                                        {obligee_name}
                                    </Badge>
                                )}
                            </StyledBadges>
                        </StyledSearchResultInfo>
                    </StyledSearchResultItem>
                );
            })}
        </StyledSearchResultList>
    );
};
